import { Tooltip } from "antd";
import { memo, useEffect, useRef } from "react";
import { Virtuoso } from "react-virtuoso";
// import whiteTick from "../../../assets/icons/whitetick.png";

const TEXT_LENGTH = 10;

const LocationList = ({
  dataEntries,
  selectedBlockKey,
  lgvListItemHandler,
}) => {
  const virtuosoRef = useRef(null);
  const lastScrolledKeyRef = useRef(null);

  // Retains the last selected location while streaming and for larger list scrolling
  useEffect(() => {
    if (!selectedBlockKey || !virtuosoRef.current) return;

    const index = dataEntries.findIndex(([key]) => key === selectedBlockKey);
    if (index === -1) return;
    if (lastScrolledKeyRef.current === selectedBlockKey) return;

    virtuosoRef.current.scrollToIndex({
      index,
      align: "center",
    });

    lastScrolledKeyRef.current = selectedBlockKey;
  }, [dataEntries, selectedBlockKey]);

  return (
    <Virtuoso
      ref={virtuosoRef}
      style={{ height: "100%", width: "100%" }}
      totalCount={dataEntries.length}
      itemContent={(index) => {
        let [location, data] = dataEntries[index];
        return (
          <div
            onClick={() => lgvListItemHandler(location, data)}
            className={`storage-list-item${
              selectedBlockKey === location ? " selected" : " unselected"
            }`}
          >
            <Tooltip
              placement="right"
              title={location.length > TEXT_LENGTH ? location : ""}
              className="flex-center"
            >
              <p>
                {location.length > TEXT_LENGTH
                  ? `${location.slice(0, TEXT_LENGTH)}...`
                  : location}
              </p>
            </Tooltip>
          </div>
        );
      }}
    />
  );
};

export default memo(LocationList);
